<template>
  <div>
    <div class="lg accesses-list">
      <scrolled-table v-if="(!loading || page > 1) && list.length" :fix-last="true" @nextPage="$emit('nextPage')">
        <table class="h-table accesses-list__table">
          <thead>
            <tr>
              <th class="accesses-list__name">
                <div class="h-table__header">
                  <div
                    class="h-table__col-title"
                    :class="{
                      active: sortBy === 'name',
                    }"
                    @click="sort('name')"
                  >
                    Название терминала
                  </div>
                </div>
              </th>
              <th class="accesses-list__terminal">
                <div class="h-table__header">
                  <div
                    class="h-table__col-title"
                    :class="{
                      active: sortBy === 'terminal_id',
                    }"
                    @click="sort('terminal_id')"
                  >
                    ID терминала (IIKO)
                  </div>
                </div>
              </th>
              <th class="accesses-list__host">
                <div class="h-table__header">
                  <div
                    class="h-table__col-title"
                    :class="{
                      active: sortBy === 'host',
                    }"
                    @click="sort('host')"
                  >
                    Хост
                  </div>
                </div>
              </th>
              <th class="accesses-list__login">
                <div class="h-table__header">
                  <div
                    class="h-table__col-title"
                    :class="{
                      active: sortBy === 'login',
                    }"
                    @click="sort('login')"
                  >
                    Логин
                  </div>
                </div>
              </th>
              <th width="70"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in list" :key="item.id" class="iiko-access">
              <td>{{ item.name }}</td>
              <td>{{ item.terminal_id }}</td>
              <td>{{ item.host }}</td>
              <td>{{ item.login }}</td>
              <td>
                <div class="iiko-access__actions">
                  <c-button2
                    v-b-popover.hover.blur.top="'Редактировать'"
                    class="iiko-access__edit"
                    size="iconic"
                    icon="edit"
                    @click="$emit('edit', item)"
                  />
                  <c-button2
                    v-b-popover.hover.blur.top="'Удалить'"
                    class="iiko-access__remove"
                    size="iconic"
                    :icon="{ icon: 'trash', color: 'secondary' }"
                    @click="$emit('remove', item)"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </scrolled-table>
      <c-loader
        v-if="loading"
        class="accesses-list__loading"
        :active="loading"
        label="Данные загружаются"
        :height="200"
      ></c-loader>
      <div v-if="!loading && !list.length" class="accesses-list__empty">
        Ничего не найдено. Попробуйте изменить параметры поиска.
      </div>
    </div>
    <div class="accesses-list sm">
      <horizontal-table v-if="(!loading || page > 1) && list.length" @nextPage="$emit('nextPage')">
        <table class="h-table">
          <tbody>
            <tr>
              <th>
                <div class="h-table__header">
                  <div
                    class="h-table__col-title"
                    :class="{
                      active: sortBy === 'name',
                    }"
                    @click="sort('name')"
                  >
                    Название<br />терминала
                  </div>
                </div>
              </th>
              <td v-for="item in list" :key="item.id">
                {{ item.name }}
              </td>
            </tr>
            <tr>
              <th>
                <div class="h-table__header">
                  <div
                    class="h-table__col-title"
                    :class="{
                      active: sortBy === 'terminal_id',
                    }"
                    @click="sort('terminal_id')"
                  >
                    ID<br />терминала<br />(IIKO)
                  </div>
                </div>
              </th>
              <td v-for="item in list" :key="item.id">
                {{ item.terminal_id }}
              </td>
            </tr>
            <tr>
              <th>
                <div class="h-table__header">
                  <div
                    class="h-table__col-title"
                    :class="{
                      active: sortBy === 'host',
                    }"
                    @click="sort('host')"
                  >
                    Хост
                  </div>
                </div>
              </th>
              <td v-for="item in list" :key="item.id">
                {{ item.host }}
              </td>
            </tr>
            <tr>
              <th>
                <div class="h-table__header">
                  <div
                    class="h-table__col-title"
                    :class="{
                      active: sortBy === 'login',
                    }"
                    @click="sort('login')"
                  >
                    Логин
                  </div>
                </div>
              </th>
              <td v-for="item in list" :key="item.id">
                {{ item.login }}
              </td>
            </tr>

            <tr>
              <th></th>
              <td v-for="item in list" :key="item.id">
                <div class="iiko-access__actions">
                  <c-button2 class="iiko-access__edit" size="iconic" icon="edit" @click="$emit('edit', item)" />
                  <c-button2
                    class="iiko-access__remove"
                    size="iconic"
                    :icon="{ icon: 'trash', color: 'secondary' }"
                    @click="$emit('remove', item)"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </horizontal-table>

      <c-loader
        v-if="loading"
        class="accesses-list__loading"
        :active="loading"
        label="Данные загружаются"
        :height="200"
      ></c-loader>

      <div v-if="!loading && !list.length" class="accesses-list__empty">
        Ничего не найдено. Попробуйте изменить параметры поиска.
      </div>
    </div>
  </div>
</template>

<script>
import CButton2 from "@/components/controls2/Button";
import ScrolledTable from "@/components/scrolled-table";
import HorizontalTable from "@/components/horizontal-table";
import CLoader from "@/components/loader";

export default {
  components: {
    CButton2,
    ScrolledTable,
    HorizontalTable,
    CLoader,
  },

  props: ["list", "loading", "page", "sortBy"],

  methods: {
    sort(sortBy) {
      this.$emit("sort", sortBy);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.accesses-list {
  &.lg {
    @media screen and (max-width: 992px) {
      .accesses-list__name {
        min-width: 140px;
      }
      .accesses-list__terminal {
        min-width: 250px;
      }
      .accesses-list__host {
        min-width: 300px;
      }
      .accesses-list__login {
        min-width: 130px;
      }
    }

    .accesses-list__empty {
      color: #8e9cbb;
      margin-top: 30px;
      font-size: 15px;
    }

    .accesses-list__loading {
      margin-top: -12px;
    }
  }
  &.sm {
    display: none;
    position: relative;

    .accesses-list__loading {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      height: 100% !important;
      min-height: 200px;

      /deep/ {
        .loader-overlay {
          background: rgba(255, 255, 255, 0.5);
        }
      }
    }

    .accesses-list__empty {
      color: #8e9cbb;
      font-size: 15px;
      padding: 0 20px;
    }

    /deep/ {
      th {
        width: 85px;
        min-width: 85px;
        max-width: 85px;
      }
      td {
        width: calc(100vw - 85px);
        min-width: calc(100vw - 85px);
        max-width: calc(100vw - 85px);
      }
    }
  }

  @include onlyMobile {
    &.lg {
      display: none;
    }
    &.sm {
      display: block;
      margin-left: -21px;
      margin-right: -21px;
    }
  }
}
.iiko-access {
  &__actions {
    display: flex;
  }
  &__edit {
    margin-right: 12px;
  }
  &__remove {
    margin-top: -3px;
  }
}
</style>
